import { SNIPPET_CATEGORY_IDS } from '../constants/snippetCategories.ts';
import type { EmptyStateVariant } from '../empty-state/EmptySnippets.tsx';

/** Values match EMPTY_STATE_VARIANT in EmptySnippets.tsx; defined here so the util works when that module is mocked in tests. */
const VARIANT = {
	SEARCH: 'search',
	MY_TEMPLATES: 'my-templates',
	FAVORITES: 'favorites',
} as const satisfies Record<string, EmptyStateVariant>;

/**
 * Returns the empty state variant to show when there are no snippets to display.
 * - When the selected category has no snippets (isCategoryEmpty): show MY_TEMPLATES, FAVORITES, or SEARCH based on category.
 * - When the category has snippets but search/filter yields none: show SEARCH.
 */
export function getEmptyStateVariant(
	isCategoryEmpty: boolean,
	selectedCategoryId: SNIPPET_CATEGORY_IDS,
): EmptyStateVariant {
	if (!isCategoryEmpty) {
		return VARIANT.SEARCH;
	}
	if (selectedCategoryId === SNIPPET_CATEGORY_IDS.MY_TEMPLATES) {
		return VARIANT.MY_TEMPLATES;
	}
	if (selectedCategoryId === SNIPPET_CATEGORY_IDS.FAVORITES) {
		return VARIANT.FAVORITES;
	}
	return VARIANT.SEARCH;
}
